<!--Navigation Bar-->
<app-navbar>
    <h2>{{'AGRI_SALARY.TITLE' | translate}}</h2>
</app-navbar>

<!--Layout Content-->
<section class="ptb-70 grey-background">
    <div class="container">
        <div class="row">
            <p [innerHTML]="'AGRI_SALARY.TEXT_HTML' | translate"></p>
        </div>                
    </div>            
</section>
<div class="privacy-layout pt-100 pb-100">
   
    <div class="container">

        <div class="form-area">

            <div class="row" *ngIf="compareInfo">
                <div class="col-12 mb-4">
                    <div class="compare-data">
                        <div class="row">
                            <div class="col-md-6 col-12 mb-4"><span class="mr-2">{{'LOGIN.COUNTRY' | translate}}:</span>{{compareFormData.country}}</div>
                            <div class="col-md-6 col-12 mb-4"><span class="mr-2">{{'LOGIN.CITY' | translate}}:</span>{{compareFormData.city}}</div>
                            <div class="col-12 mb-4"><span class="mr-2 mb-4">{{'HOMEPAGE.CARREAR_IMPROVMENT.DEPARTMENT' | translate}:</span>{{compareFormData.department}}</div>
                            <div class="col-md-6 col-12 mb-4"><span class="mr-2">{{'HOMEPAGE.CARREAR_IMPROVMENT.DOMAIN' | translate}:</span>{{compareFormData.activitySector}}</div>
                            <div class="col-md-6 col-12 mb-4"><span class="mr-2">{{'HOMEPAGE.CARREAR_IMPROVMENT.SUBDOMAIN' | translate}:</span>{{compareFormData.activitySubSector}}</div>
                            <div class="col-md-6 col-12 mb-4"><span class="mr-2">{{'HOMEPAGE.CARREAR_IMPROVMENT.EXPERIENCE' | translate}:</span>{{compareFormData.experienceLevel | enumTransform}}</div>
                            <div class="col-md-6 col-12 mb-4"><span class="mr-2">{{'HOMEPAGE.CARREAR_IMPROVMENT.SALARY' | translate}:</span>{{compareFormData.salary}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="compare-result-msg">
                        <h2 class="m-0">{{compareMessage}}</h2>
                    </div>
                </div>
            </div>
            <form (ngSubmit)="sendSalaryCompare(salaryCompare)" #salaryCompare='ngForm' *ngIf="!compareRequestSend">
                <div class="row">

                    <!--Country-->
                    <div class="col-md-6 col-12">
                        <div class="form-group">
                            <label for="country" class="c-label">{{'LOGIN.COUNTRY' | translate}}</label>
                            <select id="country"
                                    class="form-control"
                                    ngModel
                                    name="country"
                                    #country='ngModel'
                                    [ngClass]="{ 'is-invalid': salaryCompare.submitted && country.invalid }"
                                    (change)=choseCity($event)
                                    required
                            >

                                <option *ngFor="let country of location">{{country.name}}</option>
                            </select>
                            <!--Error Message-->
                            <div class="error-msg"
                                 *ngIf="!country.valid && (country.touched || salaryCompare.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>

                    <!--City-->
                    <div class="col-md-6 col-12">
                        <div class="form-group">
                            <label for="city" class="c-label">{{'LOGIN.CITY' | translate}}</label>
                            <select class="form-control"
                                    id="city"
                                    name="city"
                                    ngModel
                                    #city='ngModel'
                                    [ngClass]="{ 'is-invalid': salaryCompare.submitted && city.invalid }"
                                    required
                            >

                                <option *ngFor="let city of cities" value="{{city}}">{{city}}</option>
                            </select>

                            <!--Error Message-->
                            <div class="error-msg"
                                 *ngIf="!city.valid && (city.touched || salaryCompare.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>

                    <!--Departments-->
                    <div class="col-12">
                        <div class="form-group">
                            <label for="department" class="c-label">{{'HOMEPAGE.CARREAR_IMPROVMENT.DEPARTMENT' | translate}}</label>
                            <select class="form-control"
                                    id="department"
                                    name="department"
                                    ngModel
                                    #department='ngModel'
                                    [ngClass]="{ 'is-invalid': salaryCompare.submitted && department.invalid }"
                                    required
                            >
                                <option *ngFor="let department of selectFields.departments"
                                        value="{{department}}">{{department}}</option>
                            </select>

                            <!--Error Message-->
                            <div class="error-msg"
                                 *ngIf="!department.valid && (department.touched || salaryCompare.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>

                    <!--Domains-->
                    <div class="col-md-6 col-12">
                        <div class="form-group">
                            <label for="activitySector" class="c-label">{{'HOMEPAGE.CARREAR_IMPROVMENT.DOMAIN' | translate}}</label>
                            <select id="activitySector"
                                    class="form-control"
                                    ngModel
                                    name="activitySector"
                                    #activitySector='ngModel'
                                    [ngClass]="{ 'is-invalid': salaryCompare.submitted && activitySector.invalid }"
                                    (change)=choseSubdomains($event)
                                    required>

                                <option *ngFor="let domain of allDomains">{{domain.name}}</option>
                            </select>
                            <!--Error Message-->
                            <div class="error-msg"
                                 *ngIf="!activitySector.valid && (activitySector.touched || salaryCompare.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>

                    <!--SubDomains-->
                    <div class="col-md-6 col-12">
                        <div class="form-group">
                            <label for="activitySubSector" class="c-label">{{'HOMEPAGE.CARREAR_IMPROVMENT.SUBDOMAIN' | translate}}</label>
                            <select class="form-control"
                                    id="activitySubSector"
                                    name="activitySubSector"
                                    ngModel
                                    #activitySubSector='ngModel'
                                    [ngClass]="{ 'is-invalid': salaryCompare.submitted && activitySubSector.invalid }"
                                    required
                            >
                                <option *ngFor="let subdomain of subdomains"
                                        value="{{subdomain}}">{{subdomain}}</option>
                            </select>

                            <!--Error Message-->
                            <div class="error-msg"
                                 *ngIf="!activitySubSector.valid && (activitySubSector.touched || salaryCompare.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>

                    <!--Experience Level-->
                    <div class="col-12">
                        <div class="form-group">
                            <label for="experienceLevel" class="c-label">{{'HOMEPAGE.CARREAR_IMPROVMENT.EXPERIENCE' | translate}}</label>
                            <select class="form-control"
                                    id="experienceLevel"
                                    name="experienceLevel"
                                    ngModel
                                    #experienceLevel='ngModel'
                                    [ngClass]="{ 'is-invalid': salaryCompare.submitted && experienceLevel.invalid }"
                                    required
                            >
                                <option value="student" selected>Student</option>
                                <option value="entry_level">Proaspat Absolvent</option>
                                <option value="junior">Junior</option>
                                <option value="specialist">Specialist</option>
                                <option value="senior">Senior</option>
                                <option value="executive">Top Manager/Executiv</option>

                            </select>

                            <!--Error Message-->
                            <div class="error-msg"
                                 *ngIf="!experienceLevel.valid && (experienceLevel.touched || salaryCompare.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>

                    <!--Salary-->
                    <div class="col-12">
                        <div class="form-group">
                            <label for="salary" class="c-label">{{'HOMEPAGE.CARREAR_IMPROVMENT.SALARY' | translate}} NET</label>
                            <div class="input-group">
                                <input id="salary"
                                       type="number"
                                       class="form-control"
                                       min="0"
                                       ngModel
                                       name="salary"
                                       #salary="ngModel"
                                       [ngClass]="{ 'is-invalid': salaryCompare.submitted && salary.invalid }"
                                       required>
                                <div class="input-group-prepend">
                                    <div class="input-group-text currency-box">€/{{'HOMEPAGE.CARREAR_IMPROVMENT.MONTH' | translate}}</div>
                                </div>
                            </div>

                            <!--Error Message-->
                            <div class="error-msg"
                                 *ngIf="!salary.valid && (salary.touched || salaryCompare.submitted)">
                                {{'VALIDATION.REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>

                    <!--Submit Button-->
                    <div class="col-12">
                        <button type="submit" class="btn btn-primary w-100">
                            {{'BUTTONS.SEND' | translate}}
                        </button>
                    </div>

                </div>
            </form>
            <div class="row">
                <!--Form Message Response-->
                <div class="col-lg-12">
                    <app-form-message [success]="messageResponse" *ngIf="formSent"></app-form-message>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Footer-->
<app-footer></app-footer>
